import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/CSEASH204mid21.pdf'
import cse from '../assets/CSEASH204end21.pdf'

export default function Bee() {
  return (
    <div>
       <Subject title="Basic Electrical Engineering(ASH204)" mid="Q. Paper"
    book1="E. Hughes, “Electrical and Electronics Technology”, Pearson, 2010. " book2=" "
    book1Link="https://www.pdfdrive.com/hughes-electrical-and-electronic-technology-electronic-resource-d188314477.html"
     book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}